import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';

const Philadelphia = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/sushi' name='Фiладельфii'/>
            <main className={s.main}>
                <Product name='Філадельфія з лососем та авокадо' price='190 грн.' weight='270г./8шт.' info1='рис, норі, філаделфія, авокадо, лосось'/>
                <Product name='Філадельфія з вугрем' price='230 грн.' weight='290г./8шт.' info1='рис, норі, філаделфія, авокадо, вугор, унарі, кунжут'/>
                <Product name='Філадельфія класична з лососем' price='180 грн.' weight='260г./8шт.' info1='рис, норі, філаделфія, лосось'/>
                <Product name='Філадельфія Асорті' price='200 грн.' weight='280г./8шт.' info1='рис, норі, лосось, вугор, філадельфія, огірок, унарі, кунжут'/>
                <Product name='Філадельфія з лососем' price='150 грн.' weight='280г./8шт.' info1='рис, норі, філадельфія, огірок, лосось'/>
                <Product name='Філадельфія "Каприз"' price='210 грн.' weight='280г./8шт.' info1='рис, норі, філадельфія, ківі, груша, лосось, унарі, кокосова стружка'/>
                <Product name='Філадельфія з сиром' price='220 грн.' weight='315г./8шт.' info1='рис, норі, філадельфія, ківі, груша, лосось, сир тостовий, унарі'/>
            </main>
        </div>
    )
}

export default Philadelphia;